// import Amplify, { API } from "aws-amplify";
import axios from 'axios';
import featureFlags from "./featureFlags";
import auth from "./auth";

// let amplifyAPI = API;

/** Default config for axios instance */
// let config = {
//   baseURL: '${settings.microServiceRoot}'
// };

/** Creating the instance for axios */
let isRefreshingToken = false;
const httpClient = axios.create({
  withCredentials: true
});


const requestHandler = (request) => {
  // Modify request here

  if (!request.headers) {
    request.headers = {}
  }

  // if (localStorage.getItem("integrifyToken")) {
  //   //console.log("using request handler")
  //   request.headers.Authorization =  `Bearer ${localStorage.getItem("integrifyToken")}`
  // }

  // prevent IE11 from caching api responses
  request.headers['X-Requested-With'] = 'XMLHttpRequest'
  request.headers['Cache-Control'] = 'no-cache, no-store'
  request.headers.Expires = '0'
  request.headers.Pragma = 'no-cache'

  if (window.portalEventBus)
    window.portalEventBus.$emit('integrify-portal:serviceClient', 'request');

  return request
}
httpClient.interceptors.request.use(
  request => requestHandler(request)
)
httpClient.interceptors.response.use(function (response) {
  if (window.portalEventBus)
    window.portalEventBus.$emit('integrify-portal:serviceClient', 'response');

  if (response?.status >= 200 && response?.status < 400) 
    auth.inactivityLogout.updateLastActivity();

  return response;
}, function (error) {
  if (window.portalEventBus)
    window.portalEventBus.$emit('integrify-portal:serviceClient', 'response');

  return Promise.reject(error);
});

const errorHandler = async (error) => {
  if (error?.response?.status === 401 &&
    !error.response.config.url.includes('/api/auth/')) {
    window.portalGlobalEventBus.$emit('integrify-portal:sessionTimeout', { source: 'commonLib -> http -> errorHandler' });
  }
  
  // By default, reject the promise with the error
  return Promise.reject({...error});
}

httpClient.interceptors.response.use(
  response => response,
  error => errorHandler(error)
)

//axios.debouncedExtendSession = debouncedExtendSession;


export default httpClient;
